import { Button } from "@mui/material";
import {
  Dropdown,
  InputBox,
  Icon,
  Pagination as DynamicPagination,
  DateRangePicker,
  Modal,
} from "@components";
import { formatCurrency } from "@utils";
import {
  CDBalanceAmountListRender,
  CDBalanceOTPStep,
} from "@components/CDBalanceShared";
import { CDBALANCE_STATUS, useCDBalanceData } from "./CDBalanceData";
import "./index.scss";

const CDBalance = () => {
  const {
    balanceAmount,
    error,
    loading,
    currentBalance, // Current CD Balance from API
    fromDate,
    toDate,
    handleDateChange,

    // Handlers
    handleAmountChange,
    handleClearFilters,
    handleSubmit,
    handleDownloadMIS,
    // Data
    cdBalances: paginatedCDBalances, // Paginated CD Balances for display
    allCDBalances: cdBalances, // All filtered CD Balances for pagination component
    currentPage,
    handlePageChange,
    handleStatusFilterChange,
    selectedStatusFilter,
    otpDetails,
    handleOtpChange,
    handleCloseOtpModal,
    handleOtpSubmit,
    handleResendOTP,
  } = useCDBalanceData();

  return (
    <div className="cd-balance-page">
      <div
        className="cd-balance-page__header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1 className="cd-balance-page__title">
            C/D Balance Claims Management
          </h1>
          <p className="cd-balance-page__subtitle">
            Manage ATP credit/debit balance for claims
          </p>
        </div>

        <button
          className="cd-balance-page__download-btn"
          onClick={handleDownloadMIS}
        >
          <Icon
            iconName="downlaodIcon"
            height={16}
            width={16}
            className="download-icon"
          />
          Download Data
        </button>
      </div>

      <div className="cd-balance-page__content">
        <h2 className="cd-balance-page__balance-section">
          Current C/D Balance ={" "}
          <span className="cd-balance-page__balance-section-data">
            {formatCurrency(currentBalance)}
          </span>
        </h2>

        <div className="cd-balance-page__input-wrapper">
          <InputBox
            label="Enter Balance Amount"
            value={balanceAmount}
            onChange={handleAmountChange}
            type="text"
            placeholder="Enter amount (numbers only)"
            error={!!error}
            helperText={error}
            fullWidth={false}
            className="cd-balance-page__input"
            inputMode="decimal"
          />

          <Button
            variant="contained"
            onClick={handleSubmit}
            className="cd-balance-page__submit-btn"
            disabled={!balanceAmount}
          >
            Submit
          </Button>
        </div>
      </div>

      <div className="cd-balance-page__amount-list-table">
        <div className="cd-balance-page__table-container">
          <div className="cd-balance-page__table-header">
            <h2 className="cd-balance-page__table-title">
              Transaction History
            </h2>
            <div className="cd-balance-page__filter-controls">
              <Dropdown
                label="Transaction Type"
                value={selectedStatusFilter}
                onChange={handleStatusFilterChange}
                options={CDBALANCE_STATUS}
                className="cd-balance-page__status-dropdown"
              />
              <DateRangePicker
                fromDate={fromDate}
                toDate={toDate}
                onChange={handleDateChange}
                className="cd-balance-page__date-range-picker"
              />
            </div>
          </div>
          <button
            className="cd-balance-page__clear-btn"
            onClick={handleClearFilters}
          >
            Reset Filters
          </button>
        </div>
        <CDBalanceAmountListRender
          amounts={paginatedCDBalances}
          loading={loading}
          error={null}
          onClearFilters={handleClearFilters}
          classPrefix="cd-balance"
        />

        <DynamicPagination
          data={cdBalances}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          itemsPerPage={10}
          showInfo={true}
          showFirstButton={true}
          showLastButton={true}
        />
      </div>

      <Modal
        isOpen={otpDetails.showOtpDrawer}
        onClose={handleCloseOtpModal}
        className="cd-balance-page__modal"
        closeOnOutsideClick={false}
        showCloseIcon
      >
        <CDBalanceOTPStep
          otpVal={otpDetails.otpValue}
          otpError={otpDetails.otpError}
          loading={otpDetails.otpSubmitLoading}
          handleChange={handleOtpChange}
          handleSubmit={handleOtpSubmit}
          handleResend={handleResendOTP}
          handleCloseOtpModal={handleCloseOtpModal}
          classPrefix="cd-balance"
        />
      </Modal>
    </div>
  );
};

export default CDBalance;
